import { type DeliveryChunk } from '@/shared/api/order';

/*
 * Создает уникальную строковую сигнатуру на основе id чанков, кол-во и вариантов товаров.
 * @example
 * // Возвращает "0_1_a08d77c0-4229-4e9d-82d1-194359faf104_1_3_1839f92b-5246-43a2-b6d3-4156d6ffe83b_1_2_360a695c-ab6d-4d01-9768-38e378f254bc"
 * getOrderItemsSignature([
 *     { id: 0, items: [{ quantity: 1, product_variant_id: 'a08d77c0-4229-4e9d-82d1-194359faf104' }] },
 *     { id: 1,
 *         items: [
 *             { quantity: 3, product_variant_id: '1839f92b-5246-43a2-b6d3-4156d6ffe83b' },
 *             { quantity: 2, product_variant_id: '360a695c-ab6d-4d01-9768-38e378f254bc' },
 *         ],
 *     },
 * ]);;
 */
export const getOrderItemsSignature = (orderChunks: Array<DeliveryChunk>) =>
    orderChunks.reduce(
        (acc, chunk) =>
            acc +
            chunk.items.reduce((acc, item) => acc + `${chunk.id}_${item.quantity}_${item.product_variant_id}_`, ''),
        ''
    );
